// extracted by mini-css-extract-plugin
export default {"errorMessage":"MyFileInput_errorMessage__P9i1M"};